export enum GAMIFICATION_EVENT_TYPES {
  ACTIVE_SESSION = 'ACTIVE_SESSION',
  APPOINTMENT_SCHEDULED = 'APPOINTMENT_SCHEDULED',
  ASSIGNMENT_SUBMITTED = 'ASSIGNMENT_SUBMITTED',
  AUDIO_LISTENED = 'AUDIO_LISTENED',
  CLASS_JOINED = 'CLASS_JOINED',
  EXERCISE_COMPLETED = 'EXERCISE_COMPLETED',
  EXERCISE_PERFECT_SCORE = 'EXERCISE_PERFECT_SCORE',
  FEEDBACK_CAMPAIGN_ANSWERED = 'FEEDBACK_CAMPAIGN_ANSWERED',
  FLASHCARDS_DECK_CREATED = 'FLASHCARDS_DECK_CREATED',
  FLASHCARDS_DECK_COMPLETED = 'FLASHCARDS_DECK_COMPLETED',
  HELP_IT_TEAM = 'HELP_IT_TEAM',
  LEARNING_RESOURCE_VIEW = 'LEARNING_RESOURCE_VIEW',
  LESSON_ASK_IA = 'LESSON_ASK_IA',
  LESSON_COMPLETED = 'LESSON_COMPLETED',
  MULTIPLE_EXERCISE_ATTEMPTS_COMPLETED = 'MULTIPLE_EXERCISE_ATTEMPTS_COMPLETED',
  PROFILE_PICTURE_UPDATED = 'PROFILE_PICTURE_UPDATED',
  VIRTUAL_CLASSROOM_ATTENDED = 'VIRTUAL_CLASSROOM_ATTENDED',
}
export * from './model';
